import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { FormattedMessage, injectIntl } from 'react-intl'
import Tooltip, { ALIGN, POSITION } from 'gnos-tooltip'
import cx from 'classnames'
import _ from 'lodash'

import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'
import './style.scss'

@hocConnect
@injectIntl
export default class LevelPicker extends Component {
    static propTypes = {
        blockKey: PropTypes.string.isRequired,
        changeBlockLevel: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        levels: IPropTypes.list.isRequired,
        module: PropTypes.string.isRequired,
        // Portfolio still uses old levels (numbers), other modules use strings
        selectedLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }

    handlePickerItemClick = (level) => {
        const { module, id, blockKey, changeBlockLevel } = this.props

        changeBlockLevel(module, id, blockKey, level)
    }

    handleDecreaseLevelClick = () => {
        const { module, id, blockKey, selectedLevel, levels, changeBlockLevel } = this.props

        const indexOfSelectedLevel = levels.indexOf(selectedLevel)

        if (indexOfSelectedLevel <= 0) return null

        const nextLevel = levels.get(indexOfSelectedLevel - 1)

        if (!_.isNil(nextLevel)) changeBlockLevel(module, id, blockKey, nextLevel)
        return null
    }

    handleIncreaseLevelClick = () => {
        const { module, id, blockKey, selectedLevel, levels, changeBlockLevel } = this.props

        const indexOfSelectedLevel = levels.indexOf(selectedLevel)
        const nextLevel = levels.get(indexOfSelectedLevel + 1)

        if (!_.isNil(nextLevel)) changeBlockLevel(module, id, blockKey, nextLevel)
    }

    render() {
        const { intl, levels, selectedLevel } = this.props

        if (levels.size <= 0) return null

        const textSelector = _.isNumber(selectedLevel) ? selectedLevel : selectedLevel.split(',').slice(-1).pop()

        return (
            <div className={'block-level-picker'}>
                <span className={'title'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.levelOfContent`} />
                </span>
                {levels.size > 1 && (
                    <div className={'picker'}>
                        <button className={'picker-btn decrease'} onClick={this.handleDecreaseLevelClick} />
                        {levels.map((level, idx) => {
                            const levelTextSelector = _.isNumber(level) ? level : level.split(',').slice(-1).pop()

                            return (
                                <div
                                    key={`picker-dot-${idx}`}
                                    className={cx('picker-dot', selectedLevel === level && 'active')}
                                    onClick={() => this.handlePickerItemClick(level)}
                                    title={intl.formatMessage({ id: `${LOCALE_PREFIX}.level.${levelTextSelector}` })}
                                />
                            )
                        })}
                        <button className={'picker-btn increase'} onClick={this.handleIncreaseLevelClick} />
                    </div>
                )}
                <span className={cx('selected-level-title', levels.size <= 1 && 'padded')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.level.${textSelector}`} />
                </span>
                <Tooltip
                    id={`block-level-picker-tooltip-${Math.random()}`}
                    content={<FormattedMessage id={`${LOCALE_PREFIX}.levelPickerTooltip`} />}
                    position={POSITION.TOP}
                    align={ALIGN.CENTER}
                >
                    <div className={'help-icon'} />
                </Tooltip>
            </div>
        )
    }
}
